import { render } from "./TermsHomepage.vue?vue&type=template&id=8fbb10ce"
const script = {}

import "./TermsHomepage.vue?vue&type=style&index=0&id=8fbb10ce&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__